import { useCallback, useEffect, useState } from "react";
import { Gauge } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { useI18n } from "@/i18n/I18nContext";

const Stat = ({ label, value, testId }) => (
  <div className="min-w-0 rounded-xl border border-neutral-700 bg-[#0d0b0c] px-3 py-2">
    <div className="break-words text-[11px] uppercase tracking-wider text-neutral-400">{label}</div>
    <div className="font-display text-xl text-white" data-testid={testId}>{value}</div>
  </div>
);

export const PayGateCard = () => {
  const { t } = useI18n();
  const [s, setS] = useState(null);
  const [n, setN] = useState("");
  const load = useCallback(() => api.get("/admin/paygate").then(({ data }) => {
    setS(data);
    setN((v) => v || String(data.n));
  }).catch(() => {}), []);
  useEffect(() => {
    load();
    const id = setInterval(load, 5000);
    return () => clearInterval(id);
  }, [load]);
  const save = () => api.put("/admin/paygate", { n: Number(n) }).then(({ data }) => {
    setS(data);
    toast.success(t("paygate.saved"));
  }).catch(() => toast.error(t("err.invalidValues")));
  if (!s) return null;
  const hooks = s.webhooks.queued + s.webhooks.processing + s.webhooks.retry;
  return (
    <section className="min-w-0 rounded-2xl border border-neutral-700 bg-[#141112] p-4" data-testid="paygate-card">
      <h2 className="flex items-center gap-2 break-words font-display text-base uppercase tracking-wider text-[var(--gold-bright)] md:text-lg">
        <Gauge className="h-4 w-4 shrink-0" /> {t("paygate.title")}
      </h2>
      <div className="mt-3 grid grid-cols-2 gap-2 sm:grid-cols-4">
        <Stat label={t("paygate.inflight")} value={`${s.in_flight} / ${s.n}`} testId="paygate-inflight" />
        <Stat label={t("paygate.waiting")} value={s.waiting} testId="paygate-waiting" />
        <Stat label={t("paygate.pending")} value={s.pending_checkouts} testId="paygate-pending" />
        <Stat label={t("paygate.webhooks")} value={s.webhooks.failed ? `${hooks} · ⚠ ${s.webhooks.failed}` : hooks} testId="paygate-webhooks" />
      </div>
      <div className="mt-3 flex flex-wrap items-end gap-2">
        <label className="flex min-w-0 flex-col gap-1 text-xs font-semibold uppercase tracking-wider text-neutral-400">
          <span className="break-words">{t("paygate.max")}</span>
          <input type="number" min={1} max={100} value={n} onChange={(e) => setN(e.target.value)} className="w-28 rounded-xl border border-neutral-600 bg-[#0d0b0c] px-3 py-2 text-sm text-white focus:border-[var(--gold)] focus:outline-none" data-testid="paygate-n-input" />
        </label>
        <button type="button" onClick={save} className="rounded-full bg-[var(--gold)] px-4 py-2 text-sm font-semibold text-black transition-transform hover:-translate-y-0.5" data-testid="paygate-save-btn">{t("paygate.save")}</button>
      </div>
    </section>
  );
};
